import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Header } from '@shared/infrastructure/ui/components/header/header';
import { Sidebar } from '@shared/infrastructure/ui/components/sidebar/sidebar';

export const DashboardLayout = ({ children }: { children: ReactNode }) => {
  return (
    <Box
      sx={{
        display: 'flex'
      }}
    >
      <Box sx={{ height: '100vh', borderRight: '1px solid #555' }}>
        <Toolbar sx={{}}>
          <Typography variant='h6' component='span' sx={{ fontWeight: 'bold' }}>
            Menu
          </Typography>
        </Toolbar>
        <Sidebar></Sidebar>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%'
        }}
      >
        <Box sx={{}}>
          <Header></Header>
        </Box>
        <Box
          sx={{
            padding: '1rem 2rem'
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};
